<template>
  <v-dialog v-model="model" fullscreen scrollable>
    <v-card>
      <v-card-title>
        <span class="text-h5">
          {{ $t("add_warehouse") }}
        </span>
        <v-spacer></v-spacer>
        <print-button @click="print"></print-button>
        <circle-button
          @click="model = false"
          icon="mdi-close"
          class="ml-2"
        ></circle-button>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row style="border-bottom: 1px solid rgba(0, 0, 0, 0.12)">
          <v-col
            cols="12"
            lg="3"
            class="pt-6"
            style="border-right: 1px solid rgba(0, 0, 0, 0.12)"
          >
            <p class="title">
              {{ $t("warehouse.purchase_order") }} #{{ editedItem?.id }}
            </p>
            <v-form ref="form" v-model="valid">
              <date-picker
                v-model="editedItem.document_date"
                :label="$t('warehouse.order_date')"
                single-date
                :hide-details="false"
                color="white"
              />
              <autocomplete
                v-model="editedItem.ordered_by"
                :items="users"
                item-text="fullName"
                item-value="id"
                :loading="loadingUsers"
                :label="$t('warehouse.orderer')"
                required
                disabled
                :hide-details="false"
                :rules="[rules.required]"
                color="white"
              />
              <div>
                <choose-suplier-field
                  disabled
                  :hide-details="false"
                  v-model="editedItem.supplier_id"
                  color="white"
                />
              </div>
              <text-field
                :label="$t('warehouse.document_number')"
                v-model="editedItem.number"
                hide-details
                :hide-details="false"
                disabled
                color="white"
              />
              <text-area
                :label="$t('note')"
                :hide-details="false"
                v-model="editedItem.notes"
                rows="1"
                color="white"
              />
            </v-form>
          </v-col>
          <v-col
            class="pt-6"
            cols="12"
            lg="3"
            style="border-right: 1px solid rgba(0, 0, 0, 0.12)"
          >
            <p class="title">{{ $t("warehouse.supplier_dispatch_note") }}</p>
            <choose-warehouse-field
              :hide-details="false"
              v-model="editedItem.warehouse_id"
              color="white"
            />
            <autocomplete
              v-model="editedItem.received_by"
              :items="users"
              :hide-details="false"
              return-object
              item-text="fullName"
              :label="$t('give_in_goods')"
              required
              color="white"
            />
            <text-field
              :label="$t('warehouse.supplier_invoice_number')"
              v-model="dispatcherNumber"
              hide-details
              :hide-details="false"
              color="white"
            />

            <text-area
              :label="$t('note')"
              :hide-details="false"
              v-model="note"
              rows="3"
              color="white"
            />
          </v-col>
          <v-col cols="12" lg="6" class="pt-6">
            <v-row align="end" justify="space-between">
              <v-col cols="auto">
                <p class="title mb-2">
                  {{ $t("warehouse.supplier_delivered") }}
                </p>
              </v-col>
              <v-col style="max-width: 400px">
                <text-field
                  v-model="search"
                  prepend-inner-icon="mdi-magnify"
                  :label="$t('search')"
                  single-line
                  hide-details
                ></text-field>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filteredGroceries"
              item-key="name"
              :loading="loading"
              :items-per-page="-1"
              hide-default-footer
              class="ordera-box-shadow mt-4 striped-table"
            >
              <template v-slot:item.num="{ item, index }">
                <span>{{ index + 1 }}</span>
              </template>
              <template v-slot:item.order="{ item }">
                <text-field
                  hide-details
                  v-model="item.order"
                  :max="item.quantity"
                  :min="0"
                  dense
                  :suffix="item.measure"
                  type="number"
                  @change="checkQuantity(item)"
                ></text-field>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ moment(item.created_at).format("DD-MM-YYYY HH:mm") }}
              </template>
            </v-data-table>
            <v-btn class="mt-4" color="primary" block @click="save">
              {{ $t("add_warehouse") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasPrinting from "@/mixins/hasPrinting";
import hasValidation from "@/mixins/hasValidation";
import ChooseWarehouseField from "@/components/warehouse/field/ChooseWarehouseField.vue";
import WarehousePurchaseOrderTable from "@/components/warehouse/requirement/purchase/WarehousePurchaseOrderTable.vue";
import ChooseSuplierField from "@/components/warehouse/field/ChooseSuplierField.vue";
import { orderDocumentGrocery } from "@/models/warehouse";
import warehouseService from "@/services/warehouse";
import restaurantService from "@/services/restaurant";

export default {
  name: "WarehouseDialogOrder",
  mixins: [hasModel, hasValidation, hasSnackbar, hasPrinting],
  components: {
    ChooseWarehouseField,
    WarehousePurchaseOrderTable,
    ChooseSuplierField,
  },
  props: {
    editedItem: {
      type: Object,
      default: orderDocumentGrocery,
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      loadingUsers: false,
      note: "",
      dispatcherNumber: "",
      search: "",
    };
  },
  methods: {
    checkQuantity(item) {
      if (Number(item.order) > item.quantity || Number(item.order) < 0) {
        item.order = item.quantity;
      }
    },
    async save() {
      this.loading = true;
      let groceries = [];

      this.editedItem.groceries.forEach((item) => {
        groceries.push({
          grocery_id: item.id,
          warehouse_id: this.editedItem.warehouse_id,
          quantity: Number(item.quantity),
          order: Number(item.order),
          measure: item.measure,
          transaction_type: "entry",
          notes: this.note,
          code: item.code,
        });
      });

      const params = {
        ...this.editedItem,
        document_type: "entry",
        parent_id: this.editedItem.id,
        warehouse_id: this.editedItem.warehouse_id,
        received_by: this.editedItem.received_by?.id,
        groceries,
      };
      const request = warehouseService.addDocumentTransaction(params);
      try {
        await this.handleRequest(request, {
          successMessage: this.$t("warehouse_entry_created"),
          errorMessagePrefix: this.$t("error_creating_warehouse_entry") + ": ",
        });
        const isTotallyDelivered = groceries.every(
          (grocery) => Number(grocery.order) >= grocery.quantity
        );
        const isAnythingDelivered = groceries.some(
          (grocery) => Number(grocery.order) > 0
        );
        let status = "delivered-half";
        if (isTotallyDelivered) {
          status = "delivered";
        } else if (!isAnythingDelivered) {
          status = null;
        }
        if (status) {
          try {
            await warehouseService.patchWarehouse(this.editedItem.id, {
              data: { status },
            });
            this.showSuccessSnackbar(this.$t("warehouse_status_updated"));
          } catch (error) {
            this.showErrorSnackbar(this.$t("error_updating_warehouse_status"));
          }
        }
        this.model = false;
        this.$emit("success");
      } catch (error) {
        console.error("Failed to save invoice", error);
      } finally {
        this.loading = false;
      }
    },
    async fetchUsers(refetch = false) {
      try {
        this.loadingUsers = true;
        await this.$store.dispatch("restaurantStore/dispatchUsers", {
          refetch,
        });
      } catch (error) {
        console.error("Error fetching users:", error);
        this.showErrorSnackbar(this.$t("error_loading_users"));
      } finally {
        this.loadingUsers = false;
      }
    },
    print() {
      const deliveredDate =
        this.$t("warehouse.shipping_date") + ":" + this.localeDate(new Date());
      const orderDate =
        this.$t("warehouse.ordering_date") +
        ":" +
        this.localeDate(this.editedItem.document_date);
      const orderNumber =
        this.$t("warehouse.order_number") + ": " + this.editedItem.number;
      const deliveredNumber =
        this.$t("warehouse.invoice_number") + ": " + this.dispatcherNumber;
      const note = this.note
        ? `
            <div style="font-size: 12px;margin-top: 20px;">
            ${this.$t("note")}: ${this.note}:
            </div>
          `
        : "";

      this.printDocument({
        title: this.$t("warehouse.entry_sheet") + ` #${this.editedItem.number}`,
        hideDatetime: true,
        beforeTitleHtml: `
            <div style="display: flex;justify-content: space-between;font-size: 16px;margin-top: 20px;">
              <div>${orderNumber}</div>
              <div>${deliveredNumber}</div>
            </div>
            <div style="display: flex;justify-content: space-between;font-size: 16px;">
              <div>${orderDate}</div>
              <div>${deliveredDate}</div>
            </div>
          `,
        company1: {
          id: this.editedItem.customer?.id || 101,
          name: this.toLatin(
            [this.editedItem.customer?.name, this.editedItem.customer?.lastname].join(
              " "
            ) || ""
          ),
          city: this.toLatin(this.editedItem.customer?.city || ""),
          address: this.toLatin(this.editedItem.customer?.address || ""),
          phone: this.translate(this.editedItem.customer?.phone || ""),
          email: this.translate(this.editedItem.customer?.email || ""),
          printTitle: this.$t("warehouse.orderer"),
        },
        company2: {
          ...this.editedItem.supplier,
          printTitle: this.$t("supplier"),
        },
        signature: {
          left: {
            title: this.$t("warehouse.product_delivered_by"),
            name: this.toLatin(this.editedItem.dispatched_by?.fullName || ""),
          },
          right: {
            title: this.$t("warehouse.received_by"),
            name: this.toLatin(this.editedItem.received_by?.fullName || ""),
          },
        },
        tables: [
          {
            headers: [
              ...this.headers,
              { text: this.$t("unit_of_measurment"), value: "measure" },
            ],
            items: this.editedItem.groceries.map((item, index) => ({
              ...item,
              num: index + 1,
              name: this.toLatin(item.name),
            })),
          },
        ],
        afterTableHtml: note,
      });
    },
  },
  computed: {
    users() {
      return this.$store.state.restaurantStore.users.map((user) => ({
        ...user,
        fullName: [user.name, user.lastname].map((name) => this.toLatin(name)).join(" "),
      }));
    },
    filteredGroceries() {
      if (!this.search) {
        return this.editedItem.groceries;
      }
      const searchLower = this.translate(this.search.toLowerCase());
      return this.editedItem.groceries.filter(
        (item) =>
          this.translate(item.name.toLowerCase()).includes(searchLower) ||
          item.code.includes(searchLower)
      );
    },
    headers() {
      return [
        { text: this.$t("r_b"), value: "num" },
        {
          text: this.$t("code"),
          align: "start",
          value: "code",
        },
        {
          text: this.$t("title"),
          align: "start",
          value: "name",
        },
        {
          text: this.$t("warehouse.ordered"),
          align: "start",
          value: "quantity",
        },
        {
          text: this.$t("warehouse.delivered"),
          align: "start",
          value: "order",
          sortable: false,
        },
      ];
    },
  },
  watch: {
    model(newVal) {
      if (newVal) {
        this.fetchUsers();
      }
    },
  },
};
</script>
